import pickBy from 'lodash/pickBy'
import { UTM_KEYS } from 'library/helpers/constants'

# Query params that shouldn't be stripped when Algolia mounts
persistentQueryKeys = [ ...UTM_KEYS ]

# Make Algolia Nuxt Router adapter
# https://www.algolia.com/doc/guides/building-search-ui/going-further/routing-urls/vue/#combining-with-nuxtjs
export default (vueRouter) ->

	read: -> vueRouter.currentRoute.query

	write: (routeState) ->

		# Only push a new entry if the URL changed (avoid duplicated entries in
		# the history)
		return if @createURL(routeState) == @createURL(@read())

		# Persist query params that shouldn't be cleared from the URL
		routeState = {
			...routeState
			...pickBy vueRouter.currentRoute.query, (val, key) ->
				key in persistentQueryKeys
		}

		# Update the route
		vueRouter.push query: routeState

	createURL: (routeState) -> vueRouter.resolve(query: routeState).href

	onUpdate: (cb) ->
		return if typeof window == 'undefined'

		# Prevent double listener creation, it looks to me like the way Algolia
		# hydrates can invoke onUpadte multiple times
		return if @_onUpdateListenersAdded
		@_onUpdateListenersAdded = true

		# Update Algolia when the route changes. For some reason, this only works
		# in SPA and SSG, not on non-spa dev /shrug
		@_removeAfterEach = vueRouter.afterEach => cb @read()

		###
		# Their example registers this popstate listener but it seems to me that
		# it would have the same affect as the vueRouter.afterEach, so I've
		# disabled this for now
		@_onPopState = (e) =>
			routeState = event.state

			# On initial load, the state is read from the URL without
			# update. Therefore, the state object isn't present. In this
			# case, we fallback and read the URL.
			# if !routeState then cb(@read()) else cb(routeState)
			cb(@read())

		window.addEventListener 'popstate', @_onPopState
		###

	dispose: ->
		window?.removeEventListener 'popstate', @_onPopState if @_onPopState
		@_removeAfterEach?()
